import { dateWordShort } from "../../../helper/helper";
import { Pencil, Warning } from "../../../assets/icons";
import { useState, useEffect } from "react";
import UseContext from "../../../hooks/useContext";
import useSlideOver from "../../SlideOver/useSlideOver";
import Tooltip from "../../tooltips/Tooltips";
import { useLocation } from "react-router-dom";
import TableCell from "./TableCell";
import TableRow from "./TableRow";
import { SECTOR_CONFIG } from "../../../pages/pages/qualification/qualification";
import { qualificationText } from "../../SlideOver/dataSlideOver/data/slideOverQualification/qualificationTexts";
import { ORANGE_COLORS } from "../../../utils/colors";

const listText = (key, values) => qualificationText(`list.${key}`, values);

// The list sends tasksCount; a row refreshed from a write response carries the
// full tasks array instead, so count its active tasks rather than show 0.
const countActiveTasks = (item) => {
    if (typeof item.tasksCount === "number") return item.tasksCount;
    if (Array.isArray(item.tasks)) return item.tasks.filter((task) => task && !task.archived).length;
    return 0;
};

const tasksCountLabel = (count) => {
    if (count === 0) return listText("tasksCountZero");
    return listText(count === 1 ? "tasksCountOne" : "tasksCountOther", { count });
};

const TbodyQualification = ({ champsBody }) => {
    const { setObjID } = UseContext();
    const { toggleSlideOver } = useSlideOver();
    const location = useLocation();
    const [selectedId, setSelectedId] = useState(null);

    const editQualification = (idQualification) => {
        setSelectedId(idQualification);
        setObjID(idQualification);
        toggleSlideOver('qualification');
    };

    useEffect(() => {
        const id = new URLSearchParams(location.search).get('id');
        if (id) setSelectedId(id);
    }, [location.search]);

    return (
        <>
            {champsBody?.map((item, index) => {
                const sector = SECTOR_CONFIG[item.type] || SECTOR_CONFIG.other;
                const tasksCount = countActiveTasks(item);

                return (
                    <TableRow
                        key={item._id}
                        itemId={item._id}
                        selectedId={selectedId}
                        onClick={editQualification}
                        // What the row shows: a save from the slide-over swaps the
                        // item in place, and the full write response must not
                        // read as a change when nothing shown moved.
                        flashSignature={[item.name, item.type, item.isActive, Boolean(item.idBestt), tasksCount]}
                        className="motion-safe:animate-fadeUp"
                        style={{ animationDelay: `${Math.min(index, 9) * 30}ms` }}
                    >
                        <TableCell position="first" columnIndex={0} className="text-gray-900">
                            <div className="flex gap-2 items-center">
                                <span>{item.name}</span>
                                {item.isActive === false && (
                                    <span className="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset bg-red-50 text-red-600 ring-red-500/10">
                                        {listText("disabled")}
                                    </span>
                                )}
                                {!item.idBestt && (
                                    <Tooltip text={listText("notInBestt")} placement="right">
                                        <Warning wh={17} color="#EF4444" />
                                    </Tooltip>
                                )}
                            </div>
                        </TableCell>
                        <TableCell columnIndex={1} className="text-gray-900">
                            <span className={`inline-flex items-center rounded-md px-2 py-1 text-sm ring-1 ring-inset ${sector.className}`}>
                                {sector.label}
                            </span>
                        </TableCell>
                        <TableCell className="text-gray-900">
                            <div className="flex gap-2 items-center whitespace-nowrap">
                                {tasksCount === 0 && (
                                    <Tooltip text={listText("noTasksWarning")} placement="right">
                                        <span role="img" aria-label={listText("noTasksWarning")} className="inline-flex">
                                            <Warning wh={17} color={ORANGE_COLORS[500]} />
                                        </span>
                                    </Tooltip>
                                )}
                                <span>{tasksCountLabel(tasksCount)}</span>
                            </div>
                        </TableCell>
                        <TableCell columnIndex={2} className="text-gray-500">
                            {item.createdAt ? dateWordShort(item.createdAt) : 'N/A'}
                        </TableCell>
                        <TableCell
                            position="last"
                            hasButton
                            buttonOnClick={(e) => {
                                e.stopPropagation();
                                editQualification(item._id);
                            }}
                            buttonContent={<Pencil wh={18} color="#111827" />}
                        />
                    </TableRow>
                );
            })}
        </>
    );
};

export default TbodyQualification;